export const generateSlug = (string: string | undefined) => {
  if (!string) return 'not-found';

  return string
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[!?@#$^*`%&()\\/|'"’“~<>{}[\]:;,.+=]/g, '')
    .replace(/™|®|©/g, '');
};
